import {
	SET_START_SCHEDULE,
	SET_SELECTED_SERVICES,
	SET_VEHICLE_SCHEDULE,
	SET_DATE_SCHEDULE,
	SET_TIME_SCHEDULE,
	CLEAR_SCHEDULE_DATA,
	SET_CUSTOMER_INFO,
	SET_SCHEDULE_ERR,
	SET_STEP,
	UPDATE_SELECTED_OPTIONAL_SERVICES,
	UPDATE_INCLUDED_SERVICES,
	UPDATE_TOTAL_PRICE_BREAKDOWN,
	UPDATE_CHARGES_BREAKDOWN,
} from './mutation-types'

export default {
	[SET_START_SCHEDULE](state, status) {
		state.startSchedule = status
	},
	[SET_SELECTED_SERVICES](state, services) {
		state.selectedServices = services.filter(e => e)
	},
	[SET_VEHICLE_SCHEDULE](state, vehicle) {
		state.vehicle = vehicle;
	},
	[SET_DATE_SCHEDULE](state, date) {
		state.selectedDate = date.toISOString();
	},
	[SET_TIME_SCHEDULE](state, time) {
		state.selectedTimeSlot = time;
	},
	[SET_CUSTOMER_INFO](state, info) {
		state.customerInfo = info; 
	},
	[SET_SCHEDULE_ERR](state, info) {
		state.scheduleError = info;
	},
	[SET_STEP](state, value) {
		const index = state.step.indexOf(value.item);
		if (value.type === 'add' && index === -1) {
			state.step.push(value.item)
		} else if (value.type === 'remove' && state.step[index] && index != -1) {
			state.step.splice(index, 1)
		}
	},
	/**
	* Sets state.tireQuotePriceDetails to an Object containing {serviceTax, tireTotal, tireSalesTax, servicesTotal, overallTotal}
	* @param {Object} priceDetails - Object containing tire quote prices 
	*/
	[UPDATE_TOTAL_PRICE_BREAKDOWN](state, priceDetails) {
		state.tireQuotePriceDetails = priceDetails
	},
	/**
	* Sets state.selectedOptionalServices array
	* @param {Array} services - Array of optional selected services
	*/
	[UPDATE_SELECTED_OPTIONAL_SERVICES](state, services) {
		state.selectedOptionalServices = services
	},
	/**
	* Sets state.includedServices array
	* @param {Array} includedServices - Array of included services 
	*/
	[UPDATE_INCLUDED_SERVICES](state, includedServices) {
		state.includedServices = includedServices
	},
	/**
	* Sets state.chargesBreakdown Array
	* @param {Array} chargesBreakdown - Key-value pair of charges and their final value in dollars 
	*/
	[UPDATE_CHARGES_BREAKDOWN](state, chargesBreakdown) {
		state.chargesBreakdown = chargesBreakdown
	},
	[CLEAR_SCHEDULE_DATA](state) {
		state.startSchedule = false
		state.selectedServices = []
		state.step = []
		state.vehicle = []
		state.selectedDate = ""
		state.selectedTimeSlot = {}
		state.customerInfo = {}
		state.scheduleError = {}
		state.selectedOptionalServices = []
		state.includedServices = []
		state.tireQuotePriceDetails = {},
		state.chargesBreakdown = []
	}
}